import React from 'react';

interface ChipProps {
  text: string;
}

const Chip = (chip: ChipProps) => {
  const styles = require('./Chip.module.scss');

  return (
    <div className={styles.chip}>
      <span className={styles.text}>{chip.text}</span>
    </div>
  );
};

export default Chip;
